 
export enum FeatureFlags {
  PROTOCOLS_APP = 'apps.protocols',
  PROTOCOLS_SIGNATURE = 'apps.protocols.signature',
  TASKS_APP = 'apps.tasks',
  RECURRING_TASKS = 'apps.tasks.recurring',
  TIME_TRACKING = 'apps.tasks.time_tracking',
  TIME_TRACKING_BILLING = 'apps.tasks.time_tracking.billing',
  MY_WEEK = 'apps.tasks.my_week',
  CONTACTS_APP = 'apps.contacts',
  SEE_CENTRICS_UPDATE_NEWS = 'centrics.update_news',
  EXPORT_CLAIMS = 'feature.export_claims',
  EMAIL_PORTALS = 'feature.email_portals',
  AI_TEXT_ASSISTANT = 'feature.ai_text_assistant',
  AI_VOICE_ASSISTANT = 'feature.ai_voice_assistant',
  WEBHOOKS = 'feature.webhooks',
  SEVDESK_INTEGRATION = 'feature.integrations.sevdesk',
  MAIL_APP = 'apps.mail',
  GLOBAL_SEARCH = 'feature.global_search'
}

// @ts-ignore
export default FeatureFlags
